import React from 'react';
import SessionExpiry from '../utils/SessionExpiry';

// Thin strip pinned to the top of the viewport while the token is in its last minutes.
// Shows the minutes left, refreshed every half minute, and disappears on its own once the
// session has ended because the app shell swaps the whole page for the expired screen.
export default class SessionExpiringBanner extends React.Component {

  constructor(props) {
    super(props);
    this.state = { minutes_left: this.minutes_left() };
    this.interval = null;
  }

  componentDidMount() {
    this.interval = setInterval(() => { this.setState({ minutes_left: this.minutes_left() }); }, 30 * 1000);
  }

  componentWillUnmount() {
    if (this.interval) { clearInterval(this.interval); }
  }

  minutes_left = () => {
    let remaining = SessionExpiry.get_remaining_ms();
    if (remaining === null) { return null; }
    return Math.max(1, Math.ceil(remaining / 60000));
  }

  render() {
    let minutes = this.state.minutes_left;
    let text    = minutes === 1 ? 'Your session expires in 1 minute' : `Your session expires in ${ minutes } minutes`;

    if (minutes === null) { text = 'Your session is about to expire'; }

    return <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
      <div style={{ maxWidth: 480, width: '100%', boxSizing: 'border-box', padding: '10px 16px', backgroundColor: '#1F2937', color: 'white', fontSize: 13, fontWeight: 600, textAlign: 'center' }}>
        { text }
      </div>
    </div>
  }

}
